import React, { useState } from 'react'
import Todos from './Todos'
import Strategy from './Strategy'
import Documents from './Documents'
import Events from './Events/Events'
import Tasks from './Tasks'
import { Box, Card, CardContent, Tab, Tabs } from '@mui/material'
import DialogMessageWatcher from './dialog-message-watcher'
import { useParams } from 'react-router-dom'
import Reports from './reports'
import MotivationalQuote from './MotivationalQuote'
import PageTitle from '../common/PageTitle'
import Activity from './Activity'
import { useScreenSize } from '../hooks/useIsMobile'

const ItemContainer = ({ children, isLast }) => {
  return (
    <Card
      sx={{
        width: 'calc(50% - 16px)',
        mr: isLast ? 0 : 4,
        minWidth: '500px',
        mt: 1,
        maxHeight: '100% ',
        display: 'flex',
        flexDirection: 'column',
        alignSelf: 'stretch',
      }}
    >
      <CardContent
        sx={{ height: 'calc(100% - 40px)', flexGrow: 0, flexShrink: 1 }}
      >
        {children}
      </CardContent>
    </Card>
  )
}

const Dashboard = () => {
  const { subPath } = useParams()

  const [tab, setTab] = useState(0)

  // const isMobile = useIsMobile()

  const { windowWidth } = useScreenSize()
  const isMobile = windowWidth < 1200

  return (
    <>
      <PageTitle additionalText={new Date().toLocaleDateString()}>
        Dashboard
      </PageTitle>

      <DialogMessageWatcher />

      <Box
        sx={{
          p: 1,
          position: 'relative',
          display: 'flex',
          height: `calc(100% - ${isMobile ? 72 : 54}px)`,
        }}
      >
        {subPath === 'todos' && (
          <>
            {!isMobile && (
              <>
                <ItemContainer>
                  <Tasks />
                </ItemContainer>
                <ItemContainer isLast>
                  <Todos />
                </ItemContainer>
              </>
            )}

            {isMobile && (
              <>
                <Box
                  sx={{ width: '100%', maxHeight: '100%', overflow: 'hidden' }}
                >
                  <Tabs
                    value={tab}
                    onChange={(_, val) => setTab(val)}
                    sx={{ flexGrow: 1, mt: 0 }}
                  >
                    {['Tasks', 'To-Dos'].map((t, i) => (
                      <Tab key={i} label={t} value={i} />
                    ))}
                  </Tabs>
                  <Card
                    sx={{
                      width: '100%',
                      mt: 1,
                      height: 'calc(100% - 48px)',
                    }}
                  >
                    <CardContent
                      sx={{
                        height: 'calc(100% - 64px)',
                        flexGrow: 0,
                        flexShrink: 1,
                      }}
                    >
                      {tab === 0 && <Tasks />}
                      {tab === 1 && <Todos />}
                    </CardContent>
                  </Card>
                </Box>
              </>
            )}
          </>
          // </Box>
        )}

        {subPath === 'documents' && (
          <>
            <Box
              sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}
            >
              <Card sx={{ minWidth: '100%' }}>
                <CardContent>
                  <Documents />
                </CardContent>
              </Card>
            </Box>
          </>
        )}

        {subPath === 'strategy' && <Strategy />}

        {subPath === 'activity' && <Activity />}

        {subPath === 'events' && (
          <>
            <Events />
          </>
        )}

        {subPath === 'reports' && <Reports />}
      </Box>
    </>
  )
}

export default Dashboard
